module.exports = __webpack_public_path__ + "media/images/ecommerce/product_gallery_01-55648bafe9db9f6daf55b3d9671f4042.jpg";